"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toQueryString = toQueryString;
/**
 * Convert an object to a query string. Null/undefined values are omitted:
 * encodeURIComponent(null) would produce the literal string "null", which
 * APIs reject as an invalid value or misread as a real one.
 */
function toQueryString(obj) {
    var parts = [];
    for (var i in obj) {
        if (obj.hasOwnProperty(i) && obj[i] !== null && obj[i] !== undefined) {
            parts.push(encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]));
        }
    }
    return parts.join("&");
}
